import {
  DataCollectionMetadata,
  DataValveCDMEvent,
} from '@jarvis/shell-commons/dist/interface/v1/analytics/types'

import { getAnalyticsCorrelationId } from './get-analytics-correlation-id'

import { getCommonsNorthboundAPIs } from '@foreign-clientos/dependency-manager'

export function publishCdmEvent(
  events: DataValveCDMEvent[],
  metadata?: Omit<DataCollectionMetadata, 'xCorrelationId'>,
) {
  getCommonsNorthboundAPIs().v1.analytics.publishCdmEvents(events, {
    metadata: {
      xCorrelationId: getAnalyticsCorrelationId(),
      ...metadata,
    },
  })
}
